module.exports = {"home":{"title":"NPI System","startDate":"วันที่เริ่มต้น","endDate":"วันที่สิ้นสุด","user":"ผู้ใช้งาน","action":"สถานะ","count":"จำนวน","topActionByUser":"ผู้ใช้งานที่ใช้งานสูงสุด ในแต่ละสถานะ","version":"เวอร์ชัน"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/home.json
// module id = 558
// module chunks = 69